module.exports = __webpack_public_path__ + "static/media/10.66dfbd9c.png";